<template>
  <div class='Fuell-Overlay'>
    <div class='Fuell-Modal'>
      <div class='Fuell-Modal--window  centered'>
        <h3 class='Fuell-Modal--title'>{{$t('transactions_choose_receipt_type')}}</h3>
        <div class="choose-media-type--container">
          <label
            class="choose-media-type--button-receipt"
            :class="{'selected' : typeSelected === MEDIA_TYPE.RECEIPT}"
          >
            <img
              :src="typeSelected === MEDIA_TYPE.RECEIPT ?require('@/assets/img/icon-receipt-big-blue.svg') : require('@/assets/img/icon-receipt-big.svg')"
              alt=""
            >
            <input
              type="radio"
              name="typeSelected"
              :value="MEDIA_TYPE.RECEIPT"
              v-model="typeSelected"
            >
            <span class="choose-media-type--button-text">{{$t('transactions_receipt_type_RECEIPT')}}</span>
          </label>
          <label
            class="choose-media-type--button-bill"
            :class="{'selected' : typeSelected === MEDIA_TYPE.BILL}"
          >
            <img
              :src="typeSelected === MEDIA_TYPE.BILL ?require('@/assets/img/icon-bill-big-blue.svg') : require('@/assets/img/icon-bill-big.svg')"
              alt=""
            >
            <input
              type="radio"
              name="typeSelected"
              :value="MEDIA_TYPE.BILL"
              v-model="typeSelected"
            >
            <span class="choose-media-type--button-text">{{$t('transactions_receipt_type_BILL')}}</span>
          </label>
        </div>
        <div class="d-flex justify-content-center">
          <button
            type="button"
            @click="handleClose"
            class="Fuell-Button danger mr-2 w-25"
          >{{ $t('ACTION_CANCEL')}}
          </button>
          <button
            class="Fuell-Button blue ml-2 w-75"
            :disabled="$v.$invalid"
            :class="{'disabled' : $v.$invalid}"
            @click="setType"
          >
            {{$t('ACTION_SEND')}}
          </button>
        </div>
        <div class="d-flex align-items-center justify-content-center w-100">
          <i18n path="transactions_choose_receipt_type_disclaimer" tag="small" class="Fuell-Text">
            <template v-slot:clickHereSlot>
              <a class="text-primary" target="_blank" href="http://support.getfuell.com/es/articles/8223620-subir-gastos-digitales-que-recibes-de-tus-proveedores"> {{$t('transactions_choose_receipt_type_disclaimer_click_here')}}</a>
            </template>
          </i18n>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import { MEDIA_TYPE } from '../../_constants/MediaType'

export default {
  name: 'ChooseMediaTypeModal',
  mixins: [validationMixin, _modalHandlerMixin],
  data () {
    return {
      typeSelected: ''
    }
  },
  computed: {
    MEDIA_TYPE () {
      return MEDIA_TYPE
    }
  },
  methods: {
    setType () {
      this.$emit('typeSelected', this.typeSelected)
      this.$emit('update:open', false)
    },
    handleClose () {
      this.$emit('update:open', false)
    }
  },
  validations: {
    typeSelected: {
      required
    }
  }
}

</script>

<style scoped lang="scss">
.Fuell-Modal--close-button {
  left: 0;
  top: 0;
}
.Fuell-Modal--window {
  max-width:482px !important;
  width: 100%;
  padding: 24px;
  height: 336px;
  overflow: hidden !important;
  small {
    margin-top:20px;
    font-size:11px;
    text-align:center;
    line-height: 14px;

  }
}
.Fuell-Overlay {
  z-index: 20000 !important;
}
.disabled {
  background-color: var(--action-disabled);
  color: var(--text-disabled);
  -webkit-text-fill-color:var(--text-disabled);
  opacity:1;

}
.Fuell-Modal--title {
  height: auto;
  margin: 0;
  font-weight: 400;
  font-size: 15px;
  line-height: 15px;
  text-align: center;
  color: var(--text-body);
}
.choose-media-type {
  &--container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 16px 0;
  }
  &--button-text {
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    color: var(--text-placeholder);
  }
  &--button-receipt,
  &--button-bill {
    cursor: pointer;
    width: 127px;
    height: 127px;
    padding: 20px 31px 8px 31px;
    border: 1px solid var(--text-placeholder);
    border-radius: 8px;

    input {
      display: none;
    }

    &.selected {
      border-color: var(--semantic-brand-main);
      background-color: var(--semantic-brand-tint);

      .choose-media-type--button-text {
        color: var(--semantic-brand-main);
      }
    }
  }
}
</style>
